import { NativeError } from '../constants/minification/native-error.const.mjs';
import { normalizeIdentifier } from '../utils/normalize-identifier.util.mjs';
/**
 * Thrown when requested service was not found.
 *
 * @group Errors
 */
export class ServiceNotFoundError extends NativeError {
    constructor(identifier) {
        super();
        this.name = 'ServiceNotFoundError';
        this.normalizedIdentifier = normalizeIdentifier(identifier);
        this.message =
            `Service with "${this.normalizedIdentifier}" identifier was not found in the container. ` +
                `Register it before usage via "Container.set" or the "@Service()" decorator.`;
    }
}
//# sourceMappingURL=service-not-found.error.mjs.map